///<reference path="../../../../typings/tsd.d.ts" />

enum TypePhone {
    Mobile,
    Commercial, 
    Office
}

enum PartnerType{
    Person,
    Company
} 


class State {
    id : number;
    name : string;
}

class City {
    id : number;
    name : string;
}


class Phone {
    ddi : number;
    ddd : number;
    number : number;   
    type : TypePhone;
}

class Subsidiary {
    id : number;
    name : string;
}

class Bank {
    code : number;
    name : string;
}

class BankAgency {
    code : number;
    name : string;
}

class BankAccount {
    bank : Bank;
    agency : string;
    account : number;
}

class Address {
    cep : number;
    street : string;
    number : number;
    complement : string;
    state : State;
    city : City;
    neighborhood : string;
}

class RG{
    number : number;
    stateEmitter : string;
    organEmiitter : string;
    dateEmitter : Date;
}

class CPF{
    number : number;
}

class Partner {
    type : PartnerType;
    
}
class Company extends Partner{
    
}

class Person extends Partner {
    cpf : CPF;
    name : string;
    birth : Date;
    rg : RG;
}


class AgencyRegistration {
    
    cnpj : string;
    companyName : string;
    facyName : string;
    address : Address;
    stateRegistration : number;
    municipalRegistration : number;
    cadastur : string;
    iata : string;
    subIata : string;
    snea : string;
    url : string;
    email : string;
    password : string;
    subsidiary : Subsidiary;
    banckAccount : BankAccount;
    partners : Partner[];
    
    constructor() {
    }
}